wbApp.factory('rentCategorySvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var RentCategory = $resource('/restapi/rent-categories/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/rent-categories/:id' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/rent-categories' },
            'getAllByPlace': { method: 'GET', isArray: true, url: '/restapi/rent-categories/find-by-place' },
            'insert': { method: 'POST', url: '/restapi/rent-categories' },
            'update': { method: 'PUT', url: '/restapi/rent-categories/:id' },
            'delete': { method: 'DELETE', url: '/restapi/rent-categories/:id' },
        });

        var rentCategories;

        function createNew()
        {
            var rentCategory = {
                isNew: true,
                itemSelectionType: 1,
                rentingPeriodType: 0,
                minimumRentingPeriods: 60,
                maximumRentingPeriods: 120,
                minimumNumberOfRentedItem: 1,
                maximumNumberOfRentedItems: 1,
                rentingPeriodStepSize: 60,
                rentHourStartType: 1,
                accessPermissions: 0,
                isActive: true
            };

            return rentCategory;
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                RentCategory,
                model);
        }

        function remove(rentCategoryId) {
            rentCategories = null;
            return repositorySvc.customDelete(
                'delete',
                RentCategory,
                { id: rentCategoryId });
        }

        function update(model) {
            rentCategories = null;
            return repositorySvc.customPutWithParams(
                'update',
                RentCategory,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(rentCategoryId) {
            return repositorySvc.customGet('getById', RentCategory, { id: rentCategoryId });
        }

        function getAllByPlace(placeId) {
            return repositorySvc.customGet('getAllByPlace', RentCategory, { placeId: placeId });
        }

        function getAll(refresh) {
            if (!rentCategories || refresh) {
                rentCategories = repositorySvc.customGet('getAll', RentCategory, { includeNotActive: true });
            }
            return rentCategories;
        }

        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            getAllByPlace: getAllByPlace,
            insert: insert,
            remove: remove,
            update: update,
        }
    }
]);